import Footer from '../../components/Footer';
import Gnb from '../../components/Gnb';
import HowToAsteroids from '../../components/HowToAsteroids';

export default function PreAsteroids() {
  return (
    <>
      <Gnb />
      <HowToAsteroids />
      <Footer />
    </>
  );
}
